module.exports = __webpack_public_path__ + "img/thunderstorm.2191defd.png";